"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionEntry = ShopPageSubscriptionEntry;
const react_1 = __importDefault(require("react"));
function ShopPageSubscriptionEntry({ orderEntry, index, calculatedCount, imageRef }) {
    let productImageUrl = orderEntry.product.thumbnail.url ? orderEntry.product.thumbnail.url : "/_ui/desktop/common/assets-doterra/images/prod-unavailable.png?noVersion";
    if (index < calculatedCount.showProduct) {
        return react_1.default.createElement("a", { href: "javascript:", className: "loyalties__orders-box-product", ref: imageRef },
            react_1.default.createElement("img", { src: productImageUrl }));
    }
    else if (index == calculatedCount.showProduct && calculatedCount.entries > calculatedCount.product) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: "javascript:", className: "loyalties__orders-box-product", ref: imageRef },
                react_1.default.createElement("div", { className: "loyalties__orders-box-product-data" },
                    "+",
                    calculatedCount.plusProduct),
                react_1.default.createElement("div", { className: "loyalties__orders-box-product-overlay" }),
                react_1.default.createElement("img", { alt: "All other products", src: productImageUrl })));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
